import { SUPPLY_OPTS, supplyOf, supplyPatch } from "@/lib/lineMath";
import { Label } from "@/components/ui/label";
import { Factory } from "lucide-react";

// Satır tedarik yöntemi: gerçek kaynak stock_qty + remaining_qty + remaining_supply_method (yeni alan yok)
export function SupplyField({ form, setForm, editable, isOrder, available }) {
  const m = supplyOf(form);
  const q = Number(form.quantity || 0), sq = Number(form.stock_qty || 0);
  const locked = !!form.production_started;
  const pick = (v) => {
    if (!v) { setForm((f) => ({ ...f, stock_qty: null, remaining_supply_method: "" })); return; }
    setForm((f) => ({ ...f, ...supplyPatch(f, v, available) }));
  };
  return (
    <div className="space-y-1.5" data-testid="line-supply-field">
      <Label className="text-xs uppercase font-mono text-muted-foreground flex items-center gap-1.5">
        <Factory className="w-3.5 h-3.5" /> Tedarik Yöntemi
      </Label>
      <div className="flex gap-2">
        <select value={m} disabled={!editable || locked} onChange={(e) => pick(e.target.value)} data-testid="line-supply-select"
          className="flex-1 h-10 rounded-sm border border-input bg-background px-3 text-sm disabled:opacity-60">
          <option value="">— Sipariş geneli —</option>
          {SUPPLY_OPTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        {m === "stock_mix" && (
          <input type="number" min={1} max={Math.max(1, q - 1)} value={sq} disabled={!editable || locked} data-testid="line-supply-stock-qty"
            title="Stoktan karşılanacak adet; kalan seçilen yöntemle"
            onChange={(e) => { const s = Math.max(0, Math.min(q, Math.floor(Number(e.target.value || 0)))); setForm((f) => ({ ...f, stock_qty: s })); }}
            className="w-20 h-10 rounded-sm border border-input bg-background px-2 text-sm font-mono" />
        )}
        {m === "stock_mix" && (
          <select value={form.remaining_supply_method || "internal"} disabled={!editable || locked} data-testid="line-supply-rest"
            onChange={(e) => setForm((f) => ({ ...f, remaining_supply_method: e.target.value }))}
            className="w-36 h-10 rounded-sm border border-input bg-background px-2 text-sm">
            <option value="internal">Kalan: İç Üretim</option>
            <option value="ready_purchase">Kalan: Hazır Alım</option>
            <option value="outsourced">Kalan: Fason</option>
          </select>
        )}
      </div>
      <div className="text-[11px] text-muted-foreground" data-testid="line-supply-hint">
        {locked ? "Üretim başlatıldı — tedarik yöntemi değiştirilemez."
          : !editable ? "Bu belgede tedarik yöntemi değiştirilemez."
          : m === "stock_mix" ? `${sq} adet stoktan, ${Math.max(0, q - sq)} adet kalan yöntemle.`
          : isOrder ? "Siparişte Stoktan Satış miktarı rezervasyon nedeniyle değişmez; yalnız kalan miktarın yöntemi değiştirilebilir."
          : (m === "stock" || m === "stock_mix") && !form.warehouse_id ? "Stoktan Satış için depo seçin." : ""}
      </div>
    </div>
  );
}
